import type { GameState } from './types';

/** The browser's decoded room inventory: map plus unique selected weapons. */
export function roomAssetKey(state: Pick<GameState, 'mapId' | 'players'>): string {
  return JSON.stringify([String(state.mapId), [...new Set(state.players.map((player) => String(player.weaponId)))].sort()]);
}
